import { useHabits as _useHabits } from '@griply/hooks';
import { Habit } from '@griply/types';
import { DeletedFilter } from '@griply/utils';
import { TaskType } from 'shared/types/task-base';

import { useAllTasksOfType } from './use-all-tasks-of-type';

export const useAllHabits = (
  deletedFilter: DeletedFilter = DeletedFilter.ExcludeDeleted,
): Habit[] => {
  const tasks = useAllTasksOfType(TaskType.Habit, deletedFilter);

  return _useHabits({ tasks });
};
